import React, { useContext, useState } from "react";
import { TextField, Button } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import { server } from "../../../common";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useSelectAccess } from "../../../store/stateFunctions";
import configContext from "../../../context/configContext/configContext";

const initialValues = {
  fullname: "",
  email: "",
  contact_number: "",
  college_name: "",
  college_address: "",
  city: "",
  district: "",
  state: "",
  pincode: "",
  description: "",
  image: null,
};

const BecomeAmbassador = () => {
  const user = useSelectAccess("Student");
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      fullname: Yup.string().required("Enter a Fullname"),
      email: Yup.string().required("Enter a Email Id"),
      contact_number: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Please enter a valid Indian mobile number")
        .required("Enter a  Category"),
      college_name: Yup.string().required("Enter Your Collge Name"),
      college_address: Yup.string().required("Enter Your College Address"),
      city: Yup.string().required("Enter a City"),
      district: Yup.string().required("Enter a District"),
      state: Yup.string().required("Enter a State"),
      pincode: Yup.string().required("Enter a Pincode"),
      description: Yup.string().required("Enter a Description"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      setProcessing(true);
      setProgress(10);
      if (!values.image) {
        toast.error("Please select a images");
        return;
      }
      const formData = new FormData();
      formData.append("fullname", values.fullname);
      formData.append("email", values.email);
      formData.append("contact_number", values.contact_number);
      formData.append("college_name", values.college_name);
      formData.append("college_address", values.college_address);
      formData.append("city", values.city);
      formData.append("district", values.district);
      formData.append("state", values.state);
      formData.append("pincode", values.pincode);
      formData.append("description", values.description);
      formData.append("image", values.image);

      server
        .post("/ambassador/addambassador", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            toast.success("Request Sent successfully");
            formik.resetForm();
            setProgress(100);
          }
          setProcessing(false);
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
          setProcessing(false);
          setProgress(100);
        });
    },
  });
  return (
    <>
      <section className="">
        <div className="container py-2 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="row g-0">
              <div className=" ">
                <div className="card-body p-4 text-black">
                  <h4
                    className="mb-3 pb-3 text-center fw-bold text-uppercase"
                    style={{ letterSpacing: 1 }}
                  >
                    Become a Ambassador
                  </h4>
                  <img
                    src="/images/ambassador.png"
                    className="card-img-top mb-3"
                    height={320}
                    alt=""
                  />

                  <form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col>
                        <div className="form-outline mb-2">
                          <TextField
                            name="fullname"
                            margin="dense"
                            type="text"
                            placeholder="Student Full Name"
                            variant="outlined"
                            label="Student Full Name"
                            value={formik.values.fullname}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.fullname ? (
                            <p className="text-danger">
                              {formik.errors.fullname}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="email"
                            margin="dense"
                            type="email"
                            placeholder="Email Id"
                            variant="outlined"
                            label="Email Id"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.email ? (
                            <p className="text-danger">{formik.errors.email}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="contact_number"
                            margin="dense"
                            type="text"
                            placeholder="Contact Number"
                            variant="outlined"
                            label="Contact Number"
                            value={formik.values.contact_number}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.contact_number ? (
                            <p className="text-danger">
                              {formik.errors.contact_number}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="college_name"
                            margin="dense"
                            type="text"
                            placeholder="College Name"
                            variant="outlined"
                            label="College Name"
                            value={formik.values.college_name}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.college_name ? (
                            <p className="text-danger">
                              {formik.errors.college_name}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="college_address"
                            margin="dense"
                            type="text"
                            placeholder="College Address"
                            variant="outlined"
                            label="College Address"
                            value={formik.values.college_address}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.college_address ? (
                            <p className="text-danger">
                              {formik.errors.college_address}
                            </p>
                          ) : null}
                        </div>
                      </Col>
                      <Col>
                        <div className="form-outline mb-2">
                          <TextField
                            name="city"
                            margin="dense"
                            type="text"
                            placeholder="City"
                            variant="outlined"
                            label="City"
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.city ? (
                            <p className="text-danger">{formik.errors.city}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="district"
                            margin="dense"
                            type="text"
                            placeholder="District"
                            variant="outlined"
                            label="District"
                            value={formik.values.district}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.district ? (
                            <p className="text-danger">
                              {formik.errors.district}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="state"
                            margin="dense"
                            type="text"
                            placeholder="State"
                            variant="outlined"
                            label="State"
                            value={formik.values.state}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.state ? (
                            <p className="text-danger">{formik.errors.state}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="pincode"
                            margin="dense"
                            type="text"
                            placeholder="Pincode"
                            variant="outlined"
                            label="Pincode"
                            value={formik.values.pincode}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.pincode ? (
                            <p className="text-danger">
                              {formik.errors.pincode}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="description"
                            margin="dense"
                            type="text"
                            placeholder="Why Do You Want To Become a Campus Ambassador"
                            variant="outlined"
                            label="Why Do You Want To Become a Campus Ambassador"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {formik.errors.description ? (
                            <p className="text-danger">
                              {formik.errors.description}
                            </p>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div className="form-outline mb-2">
                      <label htmlFor="">Upload College/School ID </label>
                      <input
                        type="file"
                        name="image"
                        onChange={(event) => {
                          formik.setFieldValue(
                            "image",
                            event.currentTarget.files[0]
                          );
                        }}
                        className="form-control"
                      />
                    </div>
                    <div>
                      <input type="checkbox" name="" id="" /> &nbsp;
                      <span style={{ fontSize: "12px" }}>
                        I agree all the{" "}
                        <span>
                          <a href="">Terms & Conditions</a>
                        </span>{" "}
                        and above information is correct, if any information
                        found wrong as per company policy i am fully responsible
                        for any actions.
                      </span>
                    </div>
                    <div className="text-center">
                      <button
                        type="submit"
                        className="banner text-white rounded-5 p-2 border-0 w-50 mt-4"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BecomeAmbassador;
